<template>
  <div class="resetPassword">
    <auth-logo />

    <div class="formBox" v-if="active == 1">
      <div class="formTitle">
        <div class="label">{{ $t.auth.forgetPassword }}</div>
      </div>
      <div class="radioBox">
        <van-radio-group v-model="auth.AccountType" direction="horizontal">
          <van-radio :name="1" checked-color="#00e0b6">{{
            $t.auth.phoneNumber
          }}</van-radio>
          <van-radio :name="2" checked-color="#00e0b6">{{ $t.auth.email }}</van-radio>
        </van-radio-group>
      </div>
      <div class="inputBox" v-if="auth.AccountType == 1">
        <input
          class="username"
          v-model="auth.phoneNumber"
          type="text"
          :placeholder="$t.auth.inputPhoneNumber"
        />
      </div>
      <div class="inputBox" v-if="auth.AccountType == 2">
        <input
          class="username"
          v-model="auth.email"
          type="text"
          :placeholder="$t.auth.inputEmail"
        />
      </div>
      <div class="inputBox">
        <input
          class="password"
          v-model="auth.code"
          type="text"
          :placeholder="$t.auth.inputVcode"
        />
        <button class="getCode" v-if="isShowCode" @click="sendCode">
          {{ $t.auth.sendAuthCode }}
        </button>
        <div class="codeInfo" v-else>{{ timerNum }}S</div>
      </div>
      <div class="sub" @click="next">{{ $t.auth.next }}</div>
      <div class="next" @click="onlogin">{{ $t.auth.backLogin }}</div>
    </div>

    <div class="formBox" v-if="active == 2">
      <div class="formTitle">
        <div class="label">{{ $t.auth.resetPassword }}</div>
      </div>
      <div class="inputBox">
        <input
          class="password"
          v-model="pwdForm.password"
          type="password"
          :placeholder="$t.auth.newPassword1"
        />
      </div>
      <div class="inputBox">
        <input
          class="password"
          v-model="pwdForm.password2"
          type="password"
          :placeholder="$t.auth.newPassword2"
        />
      </div>
      <div class="sub" @click="resetPwd">{{ $t.auth.resetPassword }}</div>
    </div>

    <auth-background />
  </div>
</template>
<script>
import AuthLogo from "./components/AuthLogo";
import AuthBackground from "./components/AuthBackground";
import { Checkbox, RadioGroup, Radio } from "vant";
import Vue from "vue";
import md5 from "js-md5";

Vue.use(Checkbox).use(RadioGroup).use(Radio);
export default {
  name: "resetPassword",
  components: {
    AuthLogo,
    AuthBackground,
  },
  data() {
    return {
      active: 1,
      isShowCode: true,
      timerNum: 0,
      timerItem: null,
      auth: {
        AccountType: 1,
        phoneNumber: "",
        email: "",
        code: "",
      },
      pwdForm: {
        password: "",
        password2: "",
      },
    };
  },
  created() {},
  methods: {
    onlogin() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "auth/login",
        name: "login",
        query: [],
      });
    },
    resetPwd() {
      if (this.pwdForm.password !== this.pwdForm.password2) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.auth.diffPassword,
          type: "danger",
        });
        return false;
      }
      let param = {
        AccountType: this.auth.AccountType,
        Phone: this.auth.phoneNumber,
        Email: this.auth.email,
        Password: md5(this.pwdForm.password),
        Code: this.auth.code,
      };
      this.$commonMethod.showLoading();
      this.$api.user
        .changeUserPassword(param)
        .then((res) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.onlogin();
        })
        .catch((err) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
    next() {
      this.$commonMethod.showLoading();
      var param = {
        AccountType: this.auth.AccountType,
        Phone: this.auth.phoneNumber,
        Email: this.auth.email,
        Code: this.auth.code,
      };
      this.$api.user
        .checkAuthCode(param)
        .then(() => {
          this.$commonMethod.hideLoading();
          this.active = 2;
        })
        .catch((err) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
    sendCode() {
      const checkPhone = /^1[3|4|5|8][0-9]\d{4,8}$/;
      const phone = this.auth.phoneNumber;
      const checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const email = this.auth.email;
      if (this.auth.AccountType == 1) {
        if (checkPhone.test(phone)) {
          this.sendVerificationCode();
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.inputCorrentPhoneNumber,
            type: "danger",
          });
        }
      }
      if (this.auth.AccountType == 2) {
        if (checkEmail.test(email)) {
          this.sendVerificationCode();
        } else {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.inputCorrentEmail,
            type: "danger",
          });
        }
      }
    },
    sendVerificationCode() {
      this.$commonMethod.showLoading();
      var param = {
        AccountType: this.auth.AccountType,
        Phone: this.auth.phoneNumber,
        Email: this.auth.email,
      };
      this.$api.user
        .sendVerificationCode(param)
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.auth.verificationCodeInfo,
            type: "success",
          });
          //启动定时器
          this.timerTime();
          this.$commonMethod.hideLoading();
        })
        .catch((err) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: err.message,
            type: "danger",
          });
        });
    },
    //定时器
    timerTime() {
      this.timerNum = 120;
      this.isShowCode = false;
      this.timerItem = setInterval(() => {
        this.timerNum--;
        if (this.timerNum < 1) {
          clearInterval(this.timerItem);
          this.isShowCode = true;
        }
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.resetPassword {
  position: relative;
  width: 100%;
  //表单
  .formBox {
    width: 85%;
    position: relative;
    margin: 0 auto;
    .formTitle {
      text-align: center;
      font-weight: normal;
      margin-bottom: 2rem;
      .label {
        background: #006bb1;
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
        width: 50%;
        margin: auto;
        line-height: 44px;
        border-radius: 100px;
      }
    }
    .radioBox {
      text-align: center;
      .van-radio-group {
        display: inline-flex;
      }
      ::v-deep .van-radio__label {
        color: #fff;
      }
    }
    .inputBox {
      justify-content: space-between;
      align-items: center;
      margin-top: 18px;
      width: 100%;
      @include publicFlex;
      .username,
      .password {
        background: none;
        outline: none;
        border: none;
        -webkit-appearance: none; /*去除系统默认的样式*/
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/
        color: #f3faf8;
        font-size: 1rem;
        width: 100%;
        height: 50px;
        line-height: normal;
        border: 0.1rem solid #ffffff;
        border-radius: 100px;
        padding: 0 1.5rem;
        box-sizing: border-box;
        &::placeholder {
          color: #f3faf8;
          font-size: 1rem;
        }
        &::-webkit-input-placeholder {
          color: #f3faf8;
          font-size: 1rem;
        }
      }
      .getCode,
      .codeInfo {
        outline: none;
        border: 0;
        height: 50px;
        width: 185px;
        background-color: #ffffff;
        color: #304156;
        font-size: 0.8rem;
        text-align: center;
        border-radius: 80px;
        overflow: hidden;
        margin-left: 5%;
      }
      .codeInfo {
        font-size: 1rem;
        line-height: 50px;
        background-color: #dcdcdc;
        color: #ffffff;
      }
    }
    .next {
      margin-top: 20px;
      width: 100%;
      border-radius: 50px;
      text-align: center;
      color: #fff;
      font-size: 14px;
    }
    .sub {
      margin-top: 20px;
      width: 100%;
      height: 50px;
      line-height: 50px;
      border-radius: 50px;
      color: #304156;
      text-align: center;
      font-size: 14px;
      background-color: #ffffff;
      font-weight: bold;
    }
  }
}
</style>
